import { render, staticRenderFns } from "./office-card.vue?vue&type=template&id=c97fdfb2&"
import script from "./office-card.vue?vue&type=script&lang=js&"
export * from "./office-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports